<template>
<div>

    <b-container fluid>
        <transition name="fade">
            <p v-if="showSuccess" class="success">Event Created</p>
        </transition>

        <transition name="fade">
        <div v-if="updatingItem" class="loading">
            <p>Updating..</p>
        </div>
        </transition>
        <b-row style="magin-top:20px">
            <h3> Your Events </h3>
        </b-row>
         <b-row>
            <div class='col-8'>
                <template  v-for="(theEvent, index) in breweryEvents">   
                        <b-card 
                        bg-variant="light" 
                        border-variant="secondary"
                        class="mb-2"
                        :key='theEvent.id'
                        :footer="getAttendeesList[index]"
                        >
                        <b-form-group
                            label-cols-lg="3"
                            :label="theEvent.title"
                            label-size="lg"
                            label-class="font-weight-bold pt-0"
                            class="mb-0"
                            >
                                <b-form-group
                                    label-cols-sm="3"
                                    label="Name:"
                                    label-align-sm="right"
                                    label-for="nested-street"
                                >
                                <b-form-input  v-model="theEvent.title" id="nested-street"></b-form-input>
                                </b-form-group>
                                
                                <b-form-group
                                    label-cols-sm="3"
                                    label="Date:"
                                    label-align-sm="right"
                                    label-for="nested-street"
                                >
                                    <b-form-input  v-model="theEvent.date" type='date' id="nested-street"></b-form-input>
                                </b-form-group>

                                <b-form-group
                                    label-cols-sm="3"
                                    label="Time"
                                    label-align-sm="right"
                                    label-for="nested-city"
                                >
                                    <b-form-input  v-model="theEvent.time"  type='time' id="nested-city"></b-form-input>
                                </b-form-group>

                                <b-form-group 
                                    label-cols-sm="3"
                                    label="Description:"
                                    label-align-sm="right"
                                    label-for="description"
                                    >
                                <b-form-textarea  :maxlength="maxDescriptionLength"
                                    id="description"
                                    v-model="theEvent.description"
                                    rows="3"
                                    max-rows="6"
                                ></b-form-textarea>
                                    </b-form-group>

                            </b-form-group>
                            <b-button-group  size="sm" class="mx-1">
                                <b-button :disabled='inputError' class='btn-warning' @click="updateEvent(theEvent)">Update</b-button>
                                <b-button v-b-modal="'CancelEvent' + theEvent.id" class='btn-danger'>Cancel Event</b-button>
                                <b-modal :id="'CancelEvent' + theEvent.id" title="Cancel"  ok-title ='Yes, Cancel' cancel-title ='Do Not Cancel'  @ok="cancelEvent(theEvent.id)">
                                    <p class="my-4">Cancel {{theEvent.title}}?</p>
                                </b-modal>
                            </b-button-group>
                                RSVP'd attendees:  {{getAttendeesList[index]}}
                        </b-card>
                </template>
            </div>

            <!-- ************* New Add An Event ***************** -->
            <div class='col-4 inventorycard'>
                <h1>Create An Event</h1>
                <form @submit.prevent>
                    <label for="beerName">Title</label>
                    <div v-if='invalidTitle' class='inputwarning'>Please check title</div>
                    <input v-model="event.title" type="text" id="beerName" />
                                  
                    <label for="description">Description</label>
                    <textarea v-model.trim="event.description" :maxlength="maxDescriptionLength" id="description" placeholder="Description, 200 chars or less"> </textarea>
                    
                    <label for="quantity">Date</label>
                    <div v-if='invalidDate' class='inputwarning'>Please check date</div>
                    <input v-model="event.date" type="date" id="quantity" />

                    <label for="type">Time</label>
                    <div v-if='invalidTime' class='inputwarning'>Please enter event time</div>
                    <input v-model="event.time" type="time" id="type" />

                    <label for="Cost">Max Attendees</label>
                    <div v-if='invalidMaxAttendees' class='inputwarning'>Please enter max attendees</div>
                    <input v-model="event.maxAttendees" type="number" placeholder="20" id="cost" />

                    <label for="location">Location</label>
                    <div v-if='invalidLocation' class='inputwarning'>Please enter a location</div>
                    <textarea v-model.trim="event.location" :maxlength="maxDescriptionLength" id="location" placeholder="Location"> </textarea>

                    <div v-if="showAddEventError" class='inputwarning'> Please correct the errors above</div>
                    <button  @click="createEvent()" class="btn btn-success">Create Event</button>
                </form>

                <transition name="fade">
                    <p v-if="showSuccess" class="success">Event Added</p>
                </transition>
        </div>

            <!-- ************* End Of New Add An Event ********** -->
        </b-row>
        
        
    </b-container>
    <footer><pagefooter/></footer>
</div>
</template>

<script>    
    import { mapState } from 'vuex'
    import { currentUser, zipcodesCollection } from '../firebaseConfig'
    import moment from 'moment'
    const fb = require('../firebaseConfig.js')
    import Pagefooter from './Pagefooter'
    import {htmldatetimetounix} from './Myfunctions';
    
    export default {
        components: {
            Pagefooter,
        },
        data() {
            return {
                event:{
                    title:'',
                    description:'',
                    date:'',
                    location:'',
                    time:'16:00',
                    attendees:[],
                    waitList:[],
                    eventEnded:0,
                    comments:[],
                    maxAttendees:20,
                    cancelled:0,
                    attendeeCount:0,
                    startDate:'',
                },
                showSuccess:false,
                updatingItem:false,
                attendeesList:[],
                maxDescriptionLength:200,
                invalidTitle:false,  invalidDate:false, invalidTime:false, invalidMaxAttendees:false, invalidLocation:false, showAddEventError:false,

            }
        },
        computed: {
            ...mapState(['userProfile', 'currentUser', 'isBrewer', 'breweryEvents']),
            getAttendeesList: function () {
                 this.attendeesList=[]
                //Iterate over events
                var eventsLength = this.breweryEvents.length
                for (var j = 0; j < eventsLength; j++) {
                    var thisEvent = this.breweryEvents[j]
                    var attendees = thisEvent.attendees
                    var attendeesLength = attendees.length
                    var attendeeNames = ''
                    for (var j = 0; j < attendeesLength; j++) {
                        attendeeNames = attendeeNames + attendees[j].attendee.name
                    }
                    this.attendeesList.push(attendeeNames)
                }

                return this.attendeesList
            },
            inputError(){
                var isError = false
                //if(!this.startDate) isError = true
                return isError

            }

        },
        methods:{
            createEvent(){
                var min=11111111111111111; 
                var max=99999999999999999;  

                var newTime = htmldatetimetounix(this.event.date, this.event.time)
                this.event.startTime = newTime
       
                if(!this.event.title) this.invalidTitle = true
                else this.invalidTitle = false

                if(!this.event.date) this.invalidDate = true
                else this.invalidDate = false

                if(!this.event.time) this.invalidTime = true
                else this.invalidTime = false

                if(!this.event.maxAttendees) this.invalidMaxAttendees = true
                else this.invalidMaxAttendees = false

                if(!this.event.location) this.invalidLocation = true
                else this.invalidLocation = false

                if(this.invalidTitle||this.invalidDate||this.invalidTime||this.invalidMaxAttendees||this.invalidLocation){
                    this.showAddEventError = true
                    return
                } 
                else this.showAddEventError = false

                var randomId = Math.floor(Math.random() * (+max - +min)) + +min; 
                var randomIdString = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)

                this.event.brewer = this.userProfile.company
                this.event.brewerid = this.currentUser.uid
                this.event.id = randomIdString
                this.event.spotsremaining = this.event.maxAttendees
                this.event.cancelledrsvp = []
                this.event.startDate = Date.parse(this.event.date);

                fb.eventsCollection.add(this.event).then(() => {
                        this.showSuccess = true
                        setTimeout(() => { this.showSuccess = false }, 2000)
                        this.event.title = ''
                        this.event.description = ''
                        this.event.date = ''
                        this.event.location=''
                        this.event.time = '16:00'
                        this.event.id = ''
                        this.event.brewer = this.userProfile.company
                        
                })
            },

            updateEvent(theEvent){
                var startDate = Date.parse(theEvent.date);
                var newTime = htmldatetimetounix(theEvent.date, theEvent.time)
                this.updatingItem = true
                fb.eventsCollection.where('id', '==', theEvent.id).where('brewerid', '==', this.currentUser.uid).get().then(docs => {
                    docs.forEach(doc => {
                        fb.eventsCollection.doc(doc.id).update({
                            cancelled:0,
                            description: theEvent.description,
                            title: theEvent.title,
                            date:theEvent.date,
                            time: theEvent.time,
                            startDate: startDate,
                            startTime: newTime,
                        })
                        this.updatingItem = false
                    })
                    }).catch(err => {
                    console.log(err)
                    })

            },

            cancelEvent(theEventId){
                this.updatingItem = true
                fb.eventsCollection.where('id', '==', theEventId).where('brewerid', '==', this.currentUser.uid).get().then(docs => {
                    docs.forEach(doc => {
                        fb.eventsCollection.doc(doc.id).update({
                            cancelled:1
                        })
                        this.updatingItem = false
                    })
                    }).catch(err => {
                    console.log(err)
                    })

            },
        },

        
    }
</script>

<style>

.my-row{
    border:2px solid white
}

.my-col{
    border:2px solid white
}
</style>